import $ from 'jquery';

/**
 * 
 * @param {string} mediaID 
 * @param {string} source 
 * @param {string} type 
 * @param {string} thumbnail 
 * @param {string} cookieName 
 */
function cookiesAddMedia(mediaID, generic, source, type, thumbnail, cookieName) {
  let selectedMedia = Cookies.getJSON(cookieName);
  
  if (undefined === selectedMedia) {
    selectedMedia = {};
  }

  selectedMedia[mediaID] = {
    generic: generic,
    type: type,
    source: source,
    thumbnail: type != 'pdf' ? thumbnail : ''
  };
  Cookies.set(cookieName, selectedMedia);
}

/**
 * 
 * @param {string} mediaID 
 * @param {string} cookieName 
 */
function cookiesDeleteMedia(mediaID, cookieName) {
  let selectedMedia = Cookies.getJSON(cookieName);
  
  if (selectedMedia && delete selectedMedia[mediaID]) {
    Cookies.set(cookieName, selectedMedia);
  }
}

export default () => {
  const selectedResources = $('#selected-resources');
  const selectedDocuments = $('#selected-documents');
  const resourceList = $('.resource-list');
  const resourceItemWrapper = '.resource-item';
  const selectedResourceWrapper = '.selected-resource';
  const selectedImageTemplate = $('#selected-image-template ' + selectedResourceWrapper).first();
  const selectedVideoTemplate = $('#selected-video-template ' + selectedResourceWrapper).first();
  const selectedPDFTemplate = $('#selected-pdf-template ' + selectedResourceWrapper).first();
  const selectedMediaCookieName = 'selectedMedia';
  
  function createSelectedResource(mediaID, media) {
    let resourceToAppend = null;

    switch (media.type) {
      case 'video':
        if (selectedVideoTemplate.length == 0) {
          return;
        }

        resourceToAppend = selectedVideoTemplate.clone();
        resourceToAppend.find('.resource source').first().attr('src', media.source);
        break;
      case 'image':
        if (selectedImageTemplate.length == 0) {
          return;
        }

        resourceToAppend = selectedImageTemplate.clone();
        resourceToAppend.find('img').first().attr('src', media.source);
        break;
      case 'pdf':
      default:
        if (selectedPDFTemplate.length == 0) {
          return;
        }

        resourceToAppend = selectedPDFTemplate.clone();
        const $img = resourceToAppend.find('img').first();
        
        if (media.thumbnail) {
          $img.attr('src', media.thumbnail);
        }

        $img.attr('data-pdf-thumbnail-file', media.source);
        $img.attr('data-type', media.type);
        break;
    }
    
    resourceToAppend.find('.download-btn').first().attr('href', media.source);
    resourceToAppend.attr('data-media', mediaID); // used attr() because data-media will be queried later

    if (media.type == 'image' ||  media.type == 'video') {
      selectedResources.children('.selected-resource-list').first().append(resourceToAppend);
    } else {
      selectedDocuments.children('.selected-resource-list').first().append(resourceToAppend);
    }

    $('#' + mediaID, resourceList).closest(resourceItemWrapper).addClass('selected');
  }

  if (selectedResources.length == 1 || selectedDocuments.length == 1) {
    // One cycle for adding each media based on its' type to selected section.
    let cookiesMedia = Cookies.getJSON(selectedMediaCookieName);

    if (undefined === cookiesMedia) {
      Cookies.set(selectedMediaCookieName, {});
    } else {
      for (const prop in cookiesMedia) {
        if (cookiesMedia.hasOwnProperty(prop)) {
          createSelectedResource(prop, cookiesMedia[prop]);
        }
      }
    }

    // Event handlers.
    resourceList.on('click', '.resource-item .select-btn', function(e) {
      e.preventDefault();

      const resourceItem = $(this).closest(resourceItemWrapper); // .resource-item
      const resource = resourceItem.find('.resource').first();
      let entity = resourceItem.children('.media, .file').first();
      const fileType = resource.data('type');

      if (resourceItem.length == 0 || resource.length == 0 || entity.length == 0) {
        return;
      }

      if (resourceItem.hasClass('selected')) {
        let selected = $('.selected-resource[data-media="' + entity.attr('id') + '"]', selectedResources);

        if (selected.length == 0) {
          selected = $('.selected-resource[data-media="' + entity.attr('id') + '"]', selectedDocuments);
        }
        
        if (selected.length !== 0) {
          cookiesDeleteMedia(entity.attr('id'), selectedMediaCookieName);
          resourceItem.removeClass('selected');
          selected.remove();
        }

        return;
      }

      const r = entity.find('.resource').first();
      let entitySource = r.attr('href');
      let entityGeneric = r.attr('data-generic');
      let entityThumbnail = entity.find('.thumbnail').first().attr('src');

      createSelectedResource(entity.attr('id'), {
        generic: entityGeneric,
        source: entitySource, 
        type: fileType, 
        thumbnail: entityThumbnail
      });
      cookiesAddMedia(
        entity.attr('id'),
        entityGeneric,
        entitySource,
        fileType,
        entityThumbnail,
        selectedMediaCookieName
      );
      resourceItem.addClass('selected');
    });

    $('.selected-resource-list').on('click', '.selected-resource .unselect-btn', function(e) {
      e.preventDefault();

      let selectedResource = $(this).closest(selectedResourceWrapper);

      if (selectedResource.length == 1) {
        let mediaID = selectedResource.data('media');

        $('#' + mediaID, resourceList).closest(resourceItemWrapper).removeClass('selected');
        cookiesDeleteMedia(mediaID, selectedMediaCookieName);
        selectedResource.remove();
      }
    });

    $('.gallery-content').on('click', '.media-select', function(e) {
      e.preventDefault();

      const $galleryContent = $(this).closest('.gallery-content');
      const $galleryMedia = $galleryContent.children('#gallery-media');
      const mediaID = $galleryMedia.data('media');

      if (undefined === mediaID) {
        return;
      }

      let $resourceItem = $('#' + mediaID, resourceList).closest(resourceItemWrapper);

      if ($resourceItem.length === 0) {
        return;
      }

      if ($galleryContent.hasClass('selected')) {
        cookiesDeleteMedia(mediaID, selectedMediaCookieName);

        // Set 'heart' icon to 'unselected' state.
        $galleryContent.removeClass('selected');
        $resourceItem.removeClass('selected');

        // Remove media from selected section.
        $('.selected-resource[data-media="' + mediaID + '"]', selectedResources).remove();

        return;
      }

      let mediaThumbnail = $resourceItem.find('.thumbnail').first().attr('src');

      createSelectedResource(mediaID, {
        generic: $galleryMedia.attr('data-generic'),
        source: $galleryMedia.attr('src'), 
        type: $galleryMedia.data('type'), 
        thumbnail: mediaThumbnail
      });
      cookiesAddMedia(
        mediaID,
        $galleryMedia.attr('data-generic'),
        $galleryMedia.attr('src'),
        $galleryMedia.data('type'),
        mediaThumbnail,
        selectedMediaCookieName
      );
      $galleryContent.addClass('selected');
      $resourceItem.addClass('selected');
    });

    $('.selected-header a.link').click(function(e) {
      const $this = $(this);
      let savedMedia = Cookies.getJSON(selectedMediaCookieName);
      let preventDownload = true;

      if (undefined !== savedMedia && Object.keys(savedMedia).length > 0) {
        let arr = null;

        // Check downloadable content based on media type.
        if ($this.data('target') === 'documents') {
          arr = Object.values(savedMedia).filter(media => media.generic === 'docs');
        } else {
          arr = Object.values(savedMedia).filter(media => media.generic !== 'docs');
        }

        preventDownload = arr.length === 0;
      }

      if (preventDownload) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Download stopped');
      }
    });
  }
};
